import { render, staticRenderFns } from "./billboardBannerBottom.vue?vue&type=template&id=36b6b0c6&scoped=true&"
import script from "./billboardBannerBottom.vue?vue&type=script&lang=js&"
export * from "./billboardBannerBottom.vue?vue&type=script&lang=js&"
import style0 from "./billboardBannerBottom.vue?vue&type=style&index=0&id=36b6b0c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6b0c6",
  null
  
)

export default component.exports